import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-bon-liv',
  templateUrl: './annule-bon-liv.component.html',
  styleUrls: ['./annule-bon-liv.component.scss']
})
export class AnnuleBonLivComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
